import { Auth, Logger } from 'aws-amplify'
import store from '@/store'
import axios from 'axios'
import { i18n } from '@/plugins/i18n'

const logger = new Logger('main')
const getToken = async () =>
	(await Auth.currentSession()).getIdToken().getJwtToken()

const getUserByEmail = async (email) => {

	const token = store.state.token;
	if (!token || token === 'null') {
		throw new Error("❌ Token inválido en getUserByEmail. No se puede hacer la petición.");
	}

	const _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/user_get/list';
	const _headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: 'Bearer ' + token,
	};

	try {
		const result = await axios({ method: 'GET', url: _url, headers: _headers });
		const userResult = result.data.user;
		localStorage.setItem('UserData', JSON.stringify(userResult));
		localStorage.setItem('userRole', userResult.account_role);
		localStorage.setItem('accountType', userResult.accountType);
		localStorage.setItem('registerStep', userResult.registerStatus);
		localStorage.setItem('userEntity', userResult.entity);
		return userResult;
	} catch (error) {
		console.error("🔴 Error en getUserByEmail:", error);
		throw error;
	}
};

const getPreferenceByEmail = (email) => {
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES + '/preferences/user'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
			//'x-email': email
			//'X-referrer': 'login',
			//'X-Api-Key': process.env.VUE_APP_X_API_KEY
		}
		axios({ method: 'GET', url: _url, headers: _headers })
			.then((result) => {
				let preference = result.data
				localStorage.setItem('UserPreference', JSON.stringify(preference.data))
				resolve(preference)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

const getAccountsByEmail = (email, store) => {
	return new Promise((resolve, reject) => {
		if (JSON.parse(localStorage.getItem('storedAccounts')) === null) {
			let _url =
				process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
				'/list/mt4checkdemoaccounts'
			let _headers = {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + store.state.token,
				//'X-Api-Key': process.env.VUE_APP_X_API_KEY
			}

			axios({ method: 'GET', url: _url, headers: _headers })
				.then((result) => {
					if (result.data.response.status == 'Success') {
						localStorage.setItem(
							'DemoAccounts',
							JSON.stringify(result.data.response.data),
						)
						resolve(result.data.response.data)
					} else {
						resolve(null)
					}
				})
				.catch((error) => {
					logger.error(error)
					reject(error)
				})
		} else {
			resolve(null)
		}
	})
}

const getAccountsMt5ByEmail = (email, store) => {
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/list/mt5checkaccounts'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
			//'X-Api-Key': process.env.VUE_APP_X_API_KEY
		}

		axios({ method: 'GET', url: _url, headers: _headers })
			.then((result) => {
				if (result.data.message.status == 'Success') {
					localStorage.setItem(
						'storedAccountsmt5',
						JSON.stringify(result.data.message.data),
					)
					resolve(result.data.message.data)
				} else {
					localStorage.setItem('storedAccountsmt5', null)
					resolve(null)
					if (result.data.message.status == 1) {
						alert(result.data.message.msg)
					}
				}
			})
			.catch((error) => {
				logger.error(error)
				reject(error)
			})
	})
}

//This function create preferences - method POST
const initializePreferences = (email) => {
	//INSERT INTO PREFERENCES
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES + '/preferences/user'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
			//'x-email': email
			//'X-referrer': 'login',
			//'X-Api-Key': process.env.VUE_APP_X_API_KEY
		}
		let _data = {
			theme: 'LIGHT',
			dashboardLanguage: 'EN',
			emailsLanguage: 'EN',
			subscribedToCompanyNews: false,
			subscribedToTradingNews: false,
		}

		axios({ method: 'POST', url: _url, data: _data, headers: _headers })
			.then((result) => {
				let data = result.data
				let preference = data.preference
				resolve(preference)
			})
			.catch((error) => {
				reject(error)
			})
	})
}
const registerUserBasicStep = (ib, ib_tree) => {
	//INSERT INTO DATA BASE
	return new Promise((resolve, reject) => {
		let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/user/basic'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
		}

		let accountType = localStorage.getItem('accountTypeCreate')
			? localStorage.getItem('accountTypeCreate')
			: 'INDIVIDUAL'
		const currentPath = window.location.pathname
		let containsRegisterIBPortal = currentPath.includes('register_ib_portal')

		let _data = {
			accountType: accountType,
		}

		if (accountType === 'JOINT') {
			_data.account_role = 'primary'
		}

		if (containsRegisterIBPortal) {
			_data.applicated_as_ib = true
		}

		if (ib != 'undefined') {
			_data.ib_id = ib
		}

		if (ib_tree != 'undefined') {
			_data.ib_tree = ib_tree
		}

		axios({ method: 'POST', url: _url, headers: _headers, data: _data })
			.then((result) => {
				let data = result.data
				let user = data.user
				localStorage.setItem('migratedUser', user.is_migrate)
				resolve(user)
			})
			.catch((error) => {
				logger.error(error)
				reject(error)
			})
	})
}

// mt4 live accounts
const accountslv4 = () => {
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
			'/list/mt4checkaccounts'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
		}

		axios({ method: 'GET', url: _url, headers: _headers })
			.then((result) => {
				if (result.data.response.status == 'Success') {
					resolve(result.data.response.data)
				}
			})
			.catch((error) => {
				logger.error(error)
				reject(error)
			})
	})
}

// mt5 live accounts
const accountslv5 = () => {
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
			'/list/mt5checkaccounts'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
		}

		axios({ method: 'GET', url: _url, headers: _headers })
			.then((result) => {
				if (result.data.response.status == 'Success') {
					resolve(result.data.response.data)
				}
			})
			.catch((error) => {
				logger.error(error)
				reject(error)
			})
	})
}

//mt4 demo accounts
const accountsDm4 = () => {
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
			'/list/mt4checkdemoaccounts'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
		}

		axios({ method: 'GET', url: _url, headers: _headers })
			.then((result) => {
				if (result.data.response.status == 'Success') {
					resolve(result.data.response.data)
				}
			})
			.catch((error) => {
				logger.error(error)
				reject(error)
			})
	})
}

//mt5 demo accounts
const accountsDm5 = () => {
	return new Promise((resolve, reject) => {
		let _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
			'/list/mt5checkdemoaccounts'
		let _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
		}

		axios({ method: 'GET', url: _url, headers: _headers })
			.then((result) => {
				if (result.data.response.status == 'Success') {
					resolve(result.data.response.data)
				}
			})
			.catch((error) => {
				logger.error(error)
				reject(error)
			})
	})
}

function translateText(platform_name, translationMap) {
	if (translationMap.hasOwnProperty(platform_name)) {
		const translation = i18n.global.t(translationMap[platform_name])
		return translation
	} else {
		return platform_name
	}
}

export {
	getAccountsByEmail,
	getUserByEmail,
	getPreferenceByEmail,
	initializePreferences,
	registerUserBasicStep,
	getAccountsMt5ByEmail,
	accountslv4,
	accountsDm4,
	accountsDm5,
	accountslv5,
	translateText,
}
